import type { Element as XmlEl } from "@xmpp/xml"
import { attr } from "../../../xmlUtils"
import { InvalidStanza } from "../exceptions"
import type { EditMessage } from "../../../../types"
import { NS_ATTENSI_EDIT, NS_MESSAGE_CORRECT } from "../../../constants"

function replace(stanza: XmlEl) {
  return stanza.getChild("replace", NS_MESSAGE_CORRECT)
}

export function isEdit(stanza: XmlEl): boolean {
  return !!replace(stanza)
}

export function parseEdit(
  stanza: XmlEl
): Pick<EditMessage, "type" | "editedMessageId" | "editedAt"> {
  const editedMessageId = attr(replace(stanza), "id")
  if (!editedMessageId) throw new InvalidStanza("edit names no message", stanza)

  return { type: "edit", editedMessageId, editedAt: editedAt(stanza) }
}

/** The server's time of the latest Edit, or undefined on a message never edited. */
export function editedAt(stanza: XmlEl): number | undefined {
  const stamp = attr(stanza.getChild("edited", NS_ATTENSI_EDIT), "stamp")
  if (!stamp) return undefined
  const ms = new Date(stamp).getTime()
  return Number.isNaN(ms) ? undefined : ms
}
